// extracted by mini-css-extract-plugin
export default {"content":"mf7GPzuxXc"};